import { Path, Svg } from 'react-native-svg'

// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import { createIcon } from '../factories/createIcon'

export const [SpeechBubbles, AnimatedSpeechBubbles] = createIcon({
  name: 'SpeechBubbles',
  getIcon: (props) => (
    <Svg viewBox="0 0 36 36" fill="none" {...props}>
      <Path
        d="M31.3184 30.5911C31.6784 30.8911 31.4684 31.491 31.0034 31.491C29.4584 31.551 27.0887 31.341 25.6337 29.796C24.4487 30.216 23.1285 30.4261 21.7485 30.4261C18.7215 30.4261 16.029 29.4106 14.2485 27.5521C13.965 27.2551 14.037 26.6775 14.6865 26.7285C15.036 26.7525 15.3885 26.766 15.7485 26.766C22.6785 26.766 27.921 22.7145 29.0295 16.8525C29.1045 16.4595 29.5936 16.3291 29.8396 16.6456C30.8896 18.0046 31.4971 19.7221 31.4971 21.7546C31.4971 24.0496 30.7018 25.9711 29.3818 27.3961C29.5483 28.4461 30.1334 29.6311 31.3184 30.5911ZM26.9971 14.5065C26.9971 14.436 26.9879 14.3716 26.9865 14.3026C26.8755 8.17355 21.891 4.5 15.7485 4.5C9.53704 4.5 4.5 8.25303 4.5 14.5065C4.5 17.1585 5.412 19.3725 6.9375 21.0225C6.75 22.224 6.07513 23.5996 4.71313 24.7006C4.30063 25.0501 4.53755 25.7385 5.07605 25.7505C6.85055 25.8135 9.58805 25.575 11.2635 23.787C11.6055 23.9055 11.9564 24.0091 12.3164 24.0991C13.3979 24.3706 14.55 24.5114 15.7515 24.5114C21.96 24.5129 26.9971 20.76 26.9971 14.5065Z"
        fill={'currentColor' ?? '#222222'}
      />
    </Svg>
  ),
  defaultFill: '#222222',
})
